import { render, staticRenderFns } from "./TotalResults.vue?vue&type=template&id=4810a940&scoped=true&"
import script from "./TotalResults.vue?vue&type=script&lang=js&"
export * from "./TotalResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810a940",
  null
  
)

export default component.exports